import { createElement } from "react";
import ZOAddressSearch from "@zillow/zo-address-search";
import PropTypes from "prop-types";
const BlockZOAddressSearch = ({
  attrs,
  index
}) => /* @__PURE__ */ createElement(ZOAddressSearch, { ...attrs, key: index });
BlockZOAddressSearch.propTypes = {
  attrs: PropTypes.shape({
    origin: PropTypes.string,
    internalTrackingCode: PropTypes.string,
    entrySource: PropTypes.string,
    useNewLeadForm: PropTypes.bool,
    surfaceID: PropTypes.string,
    shouldAutoSubmit: PropTypes.bool
  }),
  index: PropTypes.number
};
export {
  BlockZOAddressSearch as default
};
